export default __webpack_public_path__ + "static/black-paper-a26ab42f2e4469a94619eda5f13930d2.png";